<template>
  <div class="body">
    <Header />
    <Video />
    <About id="about" />
    <Schedule />
    <Introduce />
    <Active id="active" />
    <Wander />
    <News id="news" />
    <Partner />
    <Ecology />
    <Media />
    <Review id="review" />
    <Footer />
  </div>
</template>

<script setup>
import Ecology from './mobile/ecology.vue'

import Header from '@/components/common/2023/header-mobile.vue'
import Video from './mobile/vedio.vue'
import About from './mobile/about.vue'
import Schedule from './mobile/schedule.vue'
import Introduce from './mobile/introduce.vue'
import Active from './mobile/active.vue'
import Wander from '@/components/index/homeMobile/mobile-wander.vue'
import News from './mobile/news.vue'
import Partner from './mobile/partner.vue'
import Media from './mobile/media.vue'
import Review from './mobile/review.vue'
import Footer from './mobile/footer.vue'
</script>

<style lang="scss" scoped>
.body {
  width: 100vw;
  overflow: hidden;
  // border: 1px solid red;
  // min-width: 414px;
}
</style>
